// extracted by mini-css-extract-plugin
export default {"avatar":"admins_avatar__DiNdZ"};